import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cell-priority',
  templateUrl: './cell-priority.component.html',
  styleUrls: ['./cell-priority.component.scss'],
})
export class CellPriorityComponent implements ICellRendererAngularComp {
  refresh;
  priority: string;
  private params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.priority = this.params?.resourceId;
  }
}
